import React, { useState } from 'react';
import { Create, TabbedForm, FormTab } from 'react-admin';
import { FormSpy } from 'react-final-form';
import { withStyles } from '@material-ui/core/styles';

import RoleSummary from './RoleSummary';
import FormTitleBar from '../../core/components/FormTitleBar';
import CreateToolbar from '../../core/components/CreateToolbar';
import NavigationPrompt from '../../core/components/NavigationPrompt';
import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';

const styles = () => ({
  noActions: {
    marginTop: '0px'
  }
});

const RoleTitle = ({ record }) => {
  return (
    <FormTitleBar
      type="Access Role"
      name=""
      status=""
      creation={true}
      showAvatar={true}
      avatarContent={'AR'}
      recordLabel="Access Role"
    />
  );
};

const RoleCreate = props => {
  const [whenBlockNavigation, setWhenBlockNavigation] = useState(false);
  const { classes } = props;
  return (
    <React.Fragment>
      <NavigationPrompt when={whenBlockNavigation} creation>
        {(isOpen, onConfirm, onCancel) => (
          <LeaveConfirm
            isOpen={isOpen}
            onConfirm={onConfirm}
            onClose={onCancel}
          />
        )}
      </NavigationPrompt>
      <Create
        {...props}
        title={<RoleTitle />}
        classes={{ noActions: classes.noActions }}
      >
        <TabbedForm
          toolbar={
            <CreateToolbar
              allowNavigationOnSave={() => setWhenBlockNavigation(false)}
            />
          }
          variant="standard"
          margin="normal"
        >
          <FormTab label="Details">
            <RoleSummary creation />
            <FormSpy
              subscription={{ dirty: true }}
              onChange={props => {
                props.dirty && setWhenBlockNavigation(props.dirty);
              }}
            />
          </FormTab>
        </TabbedForm>
      </Create>
    </React.Fragment>
  );
};

export default withStyles(styles)(RoleCreate);
